/**
 * A plan refusal from the server (`PLAN_LIMIT_REACHED`, `FEATURE_NOT_IN_PLAN`,
 * `BILLING_READ_ONLY` — only ever sent while billing is enforced) raised by a
 * change the person made. The API client reports it here; the shell's upgrade
 * prompt listens. Reads are left to the page's own error state, so nobody is
 * nagged by background refreshes.
 */
import type { ApiError } from '@/lib/api/errors';

export const PLAN_CODES = new Set([
  'PLAN_LIMIT_REACHED',
  'FEATURE_NOT_IN_PLAN',
  'BILLING_READ_ONLY',
]);

type Listener = (error: ApiError) => void;
const listeners = new Set<Listener>();

export function isPlanRefusal(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    PLAN_CODES.has(String((error as { code: unknown }).code))
  );
}

export function reportPlanRefusal(error: ApiError): void {
  if (!isPlanRefusal(error)) return;
  for (const listener of listeners) listener(error);
}

export function onPlanRefusal(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
